import { render, staticRenderFns } from "./VireedNewProject.vue?vue&type=template&id=2e76254a&"
import script from "./VireedNewProject.vue?vue&type=script&lang=js&"
export * from "./VireedNewProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports